import type {
  InquiryDataSource,
  ProductInquiryPageResponse,
} from '~/api/data-source/inquiry';
import { inquiryDataSource } from '~/api/data-source/inquiry';
import type { OAISchema } from '~/types/openapi';

// Response 타입
type ProductInquiryItem = OAISchema['MarketPlaceProductInquiryResponse'];

// Request 타입
type ProductInquiryRequest = OAISchema['MarketPlaceProductInquiryRequest'];

export interface InquiryRepository {
  // Query
  getMyInquiries(params?: {
    lastInquiryId?: number;
    size?: number;
  }): Promise<ProductInquiryPageResponse>;

  // Mutation
  editInquiry(
    inquiryId: number,
    data: ProductInquiryRequest,
  ): Promise<ProductInquiryItem>;
  deleteInquiry(inquiryId: number): Promise<ProductInquiryItem>;
}

export class InquiryRepositoryImpl implements InquiryRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: InquiryDataSource = inquiryDataSource,
  ) {}

  async getMyInquiries(params?: { lastInquiryId?: number; size?: number }) {
    return this.dataSource.getMyInquiries(params);
  }

  async editInquiry(inquiryId: number, data: ProductInquiryRequest) {
    return this.dataSource.editInquiry(inquiryId, data);
  }

  async deleteInquiry(inquiryId: number) {
    return this.dataSource.deleteInquiry(inquiryId);
  }
}

export const inquiryRepository = new InquiryRepositoryImpl();
